import {
  CarouselImageSectionRoot,
  CarouselWrapper,
  DescriptionText,
  Image,
  ItemWrapper,
  Title,
} from './styles';
import Carousel from 'react-multi-carousel';
import 'react-multi-carousel/lib/styles.css';
import { useState } from 'react';

export interface CarouselItemProps {
  id: string;
  text: string;
  image: string;
}

export interface CarouselImageWithDotsProps {
  items?: CarouselItemProps[];
  title?: string;
  backgroundColor?: string;
}

const CarouselImageWithDots = ({
  items = [],
  title,
  backgroundColor,
}: CarouselImageWithDotsProps) => {
  const [currentSlideIndex, setCurrentSlideIndex] = useState(0);

  const handleAfterChange = (
    previousSlide: number,
    { currentSlide }: { currentSlide: number }
  ) => {
    let newValue = -1;

    if (currentSlide === items.length - 2) {
      newValue = 0;
    } else if ((currentSlide + 1) % (items.length - 1) === 0) {
      newValue = newValue + 0;
    } else if (currentSlide === 2 * (items.length - 1)) {
      newValue = 0;
    } else if (currentSlide % (items.length - 1) === 0) {
      newValue = 1;
    } else {
      newValue = (currentSlide % (items.length - 1)) + 1;
    }

    setCurrentSlideIndex(newValue);
  };

  return (
    <section>
      <CarouselImageSectionRoot backgroundColor={backgroundColor}>
        {title && <Title>{title}</Title>}
        <CarouselWrapper>
          <Carousel
            responsive={{
              desktop: {
                breakpoint: { max: 3000, min: 1080 },
                items: 3,
                slidesToSlide: 1,
              },
              tablet: {
                breakpoint: { max: 1080, min: 768 },
                items: 1,
                slidesToSlide: 1,
              },
              mobile: {
                breakpoint: { max: 768, min: 0 },
                items: 1,
                slidesToSlide: 1,
              },
            }}
            arrows={false}
            showDots={true}
            autoPlay={false}
            autoPlaySpeed={3000}
            infinite={true}
            renderDotsOutside
            afterChange={handleAfterChange}
          >
            {items?.map((item, index) => (
              <ItemWrapper
                key={item.id}
                className={`${index === currentSlideIndex + 1 ? 'middle-active' : ''}`}
              >
                <DescriptionText>
                  {'"'}
                  {item.text}
                  {'"'}
                </DescriptionText>
                <Image
                  src={item.image}
                  width={166}
                  height={80}
                  alt={item.text}
                />
              </ItemWrapper>
            ))}
          </Carousel>
        </CarouselWrapper>
      </CarouselImageSectionRoot>
    </section>
  );
};

export default CarouselImageWithDots;
